import React, { useContext, useEffect, useRef, useState } from "react";
import { getImages } from "../Components/Const";
import { LeadsContext } from "../Components/Context/LeadsContext";
import LeadItem from "../Components/Leads/LeadItem";
import ModalLayout from "../Components/Modals/ModalLayout";
import PlainTextEmail from "../Components/Modals/PlainTextEmail";
import CreateNotesModal from "../Components/Leads/CreateNotesModal";
import ScriptModal from "../Components/Modals/ScriptModal";
import TextLead from "../Components/Leads/TextLead";
import MobLeadItem from "../Components/Leads/MobLeadItem";
import AutoComplete from "../Components/Common/AutoComplete";
import WaitingResponseModal from "../Components/Leads/WaitingResponseModal";
import SetAppointmentModal from "../Components/Leads/SetAppointmentModal";
import TaskDetailsModal from "../Components/Leads/TaskDetailsModal";
import ModalLayoutNew from "../Components/Modals/ModalLayoutNew";
import AppraisalDetails from "../Components/Customers/AppraisalDetails";
import AlertModal from "../Components/Modals/AlertModal";

const useIsMobile = (breakpoint = 992) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    // Set initial value
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};

const Leads = ({ allLeadData, handleBackBtn, filteredLeads, handleDashTab, leadType, dashTabActive, leadLocation, tabClick }) => {

  const { singlePagination, leadsLoading, leadSearch, activeLeadID, updateTask, updateLeadDataMultiple, archivedLeadData, activeLeadAction, allLeads } = useContext(LeadsContext);

  const isMobile = useIsMobile();

  const queryParameters = new URLSearchParams(window.location.search);

  useEffect(() => {
    console.log("leads useeffect", filteredLeads);
  }, []);

  /*plain text email modal*/
  const [plainTextEmail, setPlainTextEmail] = useState(false);
  const [selectedLead, setSelectedLead] = useState({});

  const [selectedScript, setSelectedScript] = useState(null);

  const openPlainTextEmail = (selectedLead, selectedScript = null) => {
    setSelectedScript(selectedScript)
    setPlainTextEmail(true);
    setSelectedLead(selectedLead);
  };
  const paintextEmailClose = () => {
    setPlainTextEmail(false);
  };
  /*plain text email modal*/

  /*add script modal*/

  const [addScriptModal, setScriptModal] = useState(false);

  const [scriptType,setScriptType] = useState("email");

  const scriptModalClose = () => {
    setScriptModal(false);
  };

  /*add script modal*/

  /*expand lead section*/

  const [openLead, setOpenLead] = useState(null);

  useEffect(() => {
    //handleAccordionClick(activeLeadID);

    //console.log("leads activeleadid useeffect",activeLeadID);

    var foundLead = allLeadData.filter((lead) => lead.id == activeLeadID);
    var lead_found = false;
    
    if(foundLead.length) {
      foundLead = foundLead[0];
      console.log("found it", foundLead);
      handleDashTab("leadsTab",foundLead.lead_type,foundLead.location);
      handleAccordionClick(foundLead.lead_id);
      lead_found = true;
    } else {

      foundLead = archivedLeadData.filter((lead) => lead.id == activeLeadID);

      if(foundLead.length) {
        foundLead = foundLead[0];
        console.log("found it all archived", foundLead);
        handleDashTab("leadsTab","archived",foundLead.location);
        handleAccordionClick(foundLead.lead_id);
        lead_found = true;
      } else {

        /*foundLead = allLeads.filter((lead) => lead.id == activeLeadID);

        if(foundLead.length) {
          foundLead = foundLead[0];
          console.log("found it all leads", foundLead);
          handleDashTab("leadsTab","archived",foundLead.location);
          handleAccordionClick(foundLead.lead_id);
          lead_found = true;
        }*/
      }
    }

    if(lead_found && queryParameters.has('text')) textLeadModal(foundLead);
    if(lead_found && queryParameters.has('email')) openPlainTextEmail(foundLead);

    if(lead_found && activeLeadAction == "text") textLeadModal(foundLead);
    if(lead_found && activeLeadAction == "email") openPlainTextEmail("AppraisalSendEmail");

  }, [leadSearch,activeLeadID]);


  const handleAccordionClick = (lead_id) => {
    setOpenLead(openLead === lead_id ? null : lead_id);
  };

  /*expand lead section*/

  /*create note modal*/

  const [createNoteOpen, setCreateNoteOpen] = useState(false);
  const [noteLeadData, setNoteLeadData] = useState([]);
  const [openNotesMobModal, setOpenNotesMobModal] = useState(false);
  const createNoteOpenModal = (leadData) => {
    setCreateNoteOpen(true);
    setNoteLeadData(leadData);
    setOpenNotesMobModal(false)
    document.body.classList.remove('mob-overflow-body');
  };
  const createNoteCloseModal = () => {
    setCreateNoteOpen(false);
  };

  const handleNotesMobileModal = () => {
    setOpenNotesMobModal(true);
    document.body.classList.add('mob-overflow-body');
  };
  const closeNotesMobModal = () => {
    setOpenNotesMobModal(false);
    document.body.classList.remove('mob-overflow-body');
  };
  //console.log("openNotesMobModal", openNotesMobModal)
  /*create note modal*/

  /*text email modal*/

  const [textLead, setTextLead] = useState(false);
  const [currentPageData, setCurrentPageData] = useState([]);

  const textLeadModal = (selectedLead) => {
    setTextLead(true);
    setSelectedLead(selectedLead)
  };
  const textLeadCloseModal = () => {
    setTextLead(false);
  };

  /*text email modal*/

  // Pagination 
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  useEffect(() => {
    setCurrentPage(1);
  }, [dashTabActive,leadType,leadLocation]);

  useEffect(() => {
    paginationSetup();

    const timer = setTimeout(() => {
        addAssocLeads();
    }, 500);

    const processedLeads = filteredLeads?.slice(startIndex, endIndex).map((v) => {
        v.assocLeads = [];
        return v;
    });
    
    setCurrentPageData(processedLeads);

    return () => {
        clearTimeout(timer);
    };
  }, [filteredLeads,currentPage]);

  const addAssocLeads = () => {
    console.log("adding assoc");
      const processedLeads = filteredLeads?.slice(startIndex, endIndex).map((v) => {
          v.assocLeads = allLeads.filter((lead) => (lead.id != v.id.toString())).filter((lead) => ( //lead.appraisal > 0 && 
              (v.email && lead.email && lead.email.toLowerCase().replace(/[^a-zA-Z0-9]/g, '') == v.email.toLowerCase().replace(/[^a-zA-Z0-9]/g, '') ||
              v.phone &&  lead.phone && lead.phone.toLowerCase().replace(/[^a-zA-Z0-9]/g, '') == v.phone.toLowerCase().replace(/[^a-zA-Z0-9]/g, ''))
          ));
          return v;
      });

      setCurrentPageData(processedLeads);
  }


  const maxPaginationLength = 8;
  const [totalPages,setTotalPages] = useState(Math.ceil(filteredLeads?.length / pageSize));

  // Function to handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  // Function to handle next page
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  // Function to handle previous page
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const [paginationButtons, setPaginationButtons] = useState([]);

  useEffect(() => {

    paginationSetup();

  }, [singlePagination, dashTabActive, leadType, leadLocation, currentPage]);

  const [openLeadFilter, setOpenLeadFilter] = useState(false)
  const handleLeadFilter = () => {
    setOpenLeadFilter(!openLeadFilter)
  }
  const [openMobArrow, setOpenMobArrow] = useState(false);
  const [mobLeadItem, setMobLeadItem] = useState('');
  const handleMobArrow = (leadItem) => {
    setOpenMobArrow(true);
    setMobLeadItem(leadItem);
  }
  const closeMobItem = () => {
    setOpenMobArrow(false);
    document.body.classList.remove('mob-overflow-body');
  }
  const cancelMobLeadItem = () => {
    setMobLeadItem('');
  }
  // Waiting Response
  const [dealStageModal, setDealStageModal] = useState(false);

  const [dealStageLeadData, setDealStageLeadData] = useState([]);

  const openDealStageModal = (leadData) => {
    setDealStageLeadData(leadData);
    setDealStageModal(true);
    document.body.classList.add('overflow-body');
  }
  const closeDealStageModal = () => {
    setDealStageModal(false);
    document.body.classList.remove('overflow-body');
  }
  // Set Appointment
  const [openSetAppointment, setOpenSetAppointment] = useState(false);
  const handleSetAppointment = (selectedLead) => {
    setOpenSetAppointment(true);
    document.body.classList.add('overflow-body');    
    setSelectedLead(selectedLead);
  }
  const closeSetAppointment = () => {
    setOpenSetAppointment(false);
    document.body.classList.remove('overflow-body');
  }

  // Task Details
  const [openTaskDetails, setOpenTaskDetails] = useState(false);
  const [openEditTaskDetails, setOpenEditTaskDetails] = useState("");
  const handleTaskDetails = (taskEditDtl) => {
    // console.log(taskEditDtl);
    setOpenTaskDetails(true);
    setOpenEditTaskDetails(taskEditDtl);
    document.body.classList.add('overflow-body');
  }
  const closeTaskDetails = () => {
    setOpenTaskDetails(false);
    document.body.classList.remove('overflow-body');
  }
  // Task Details
  const [openAppraisalModal, setOpenAppraisalModal] = useState(false);
  const [openAppraisalDetails, setOpenAppraisalDetails] = useState("");
  // console.log("openAppraisalDetails", openAppraisalDetails)
  const handleAppraisalDetails = (taskAppraisalDtl) => {
    setOpenAppraisalModal(true);
    setOpenAppraisalDetails(taskAppraisalDtl);
    document.body.classList.add('overflow-body');
  }
  const closeAppraisalDetails = () => {
    setOpenAppraisalModal(false);
    document.body.classList.remove('overflow-body');
  }

  const leadSortingOptions = [
    {"label":"MOST RECENT","field":"created_at_obj"},
    {"label":"OLDEST TASK","field":"task_start_diff"}
  ]

  const [leadSorting,setLeadSorting] = useState(leadSortingOptions[0].field);

  // Alert Modal 
  /*const [noteRemoveAlert, setNoteRemoveAlert] = useState(false); /web
  const [noteRemoveID, setNoteRemoveID] = useState(""); 

  const handleNoteRemove = (id) => {
    setNoteRemoveAlert(true);
    setNoteRemoveID(id);
    document.body.classList.add('overflow-body');
  }
  const closeNoteRemove = () => {
    setNoteRemoveAlert(false);
    document.body.classList.remove('overflow-body');
  }
  const handleSendNoteData = () => {
    deleteNote(noteRemoveID);
    setNoteRemoveAlert(false);
    document.body.classList.remove('overflow-body');
  }*/

  const paginationSetup = () => {
    var total_pages = Math.ceil(filteredLeads?.length / pageSize);
    setTotalPages(total_pages);

    const buttons = [];
    let startPage, endPage;

    if (total_pages <= maxPaginationLength) {
      startPage = 1;
      endPage = total_pages;
    } else {
      const halfMax = Math.floor(maxPaginationLength / 2);
      if (currentPage <= halfMax) {
        startPage = 1;
        endPage = maxPaginationLength;
      } else if (currentPage + halfMax >= total_pages) {
        startPage = total_pages - maxPaginationLength + 1;
        endPage = total_pages;
      } else {
        startPage = currentPage;
        endPage = currentPage + Math.floor(maxPaginationLength - 1);
      }
    }
    
    //console.log("setting up pagination",filteredLeads?.length,total_pages,startPage,endPage);

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(i);
    }
    setPaginationButtons(buttons);
  }
  return (
    <>
      {/* {console.log("filteredLeads", filteredLeads)} */}
      <div className="lead-list-block">
        <div className='d-lg-none'>
          <button className='mob-back-btn' type='button' onClick={handleBackBtn}><span><img src={getImages('left-arrow.svg')} /></span> Back</button>
        </div>
        <div className='d-flex align-items-center justify-content-between filter-block lead-filter-block'>
          <div className="d-flex align-items-center justify-content-between">
            <div className='main-heading'>{leadType == "archived" ? "ARCHIVED" : "ACTIVE"} LEADS</div>
            <div className="d-lg-none text-end">
              <button type="button" onClick={handleLeadFilter} className="blue-transparent-btn text-uppercase filter-btn"><img src={getImages('filter-icon.svg')} /> Filters</button>
            </div>
          </div>

          <div className={`d-inline-flex align-items-center list_filter ${openLeadFilter && 'selected'}`}>
            <div className='d-flex align-items-center filter-col'>
              <label>DATE FILTER</label>
              <select className="form-control">
                <option value="all days">All Days</option>
              </select>
            </div>
            <div className="d-flex align-items-center filter-col ms-4">
              <label>SORT BY</label>
              <select className="form-control" onChange={(e) => setLeadSorting(e.target.value)} defaultValue={leadSorting}>
                {leadSortingOptions.map((v,i) => 
                  <option value={v.field} key={i}>{v.label}</option>
                )}
              </select>
            </div>
            <div className="d-flex align-items-center filter-col ms-4">
              <label>RANGE</label>
              <select className="form-control">
                <option value="high to low">High to Low</option>
              </select>
            </div>
          </div>
          <div className="d-lg-none search-for-mob">
            {isMobile && <AutoComplete
              openMobArrow={openMobArrow}
              handleMobArrow={handleMobArrow}
              inPerson={false}
              tabClick={tabClick}
            />}
          </div>
        </div>
        <div className="custom-table mnh-30vh">
          {filteredLeads && !filteredLeads.length > 0 ?
          <>
            {/* <div className="text-white text-center py-5 my-5">
              {allLeadData ? 'No Search Results' : 'Loading...'}
            </div> */}
            <div className='loading-cardrop-box loading-for-dark-theme'>
                {!leadsLoading ? <></> : <img className='loading-cardrop-image' src={getImages('loading-cardrop.gif')} alt=''/>}
                <div className='xs-title text-center text-white text-uppercase font-1em'>{!leadsLoading ? 'No Results' : 'Loading...'}</div>
            </div>
            </>
            :
            <>
              <table className="w-100">
                <thead>
                  <tr>
                    <td className="p-0">
                      <table className="w-100">
                        <thead>
                          <tr>
                            <th style={{ width: "5%" }}>&nbsp;</th>
                            <th style={{ width: "23%" }}>Customer Name</th>
                            <th className="text-center" style={{ width: "8%" }}>Repeat Client</th>
                            <th style={{ width: "15%" }}>Vehicle Info</th>
                            <th className="text-center" style={{ width: "6%" }}>
                              Task Day
                            </th>
                            <th className="text-center" style={{ width: "6%" }}>
                              Appraisal
                            </th>
                            <th className="text-center" style={{ width: "6%" }}>
                              Email Sent
                            </th>
                            <th className="text-center" style={{ width: "6%" }}>
                              Phone Call
                            </th>
                            <th className="text-center" style={{ width: "6%" }}>
                              Notes
                            </th>
                            <th className="text-center" style={{ width: "6%" }}>
                              Day In
                            </th>
                            <th className="text-center" style={{ width: "16%" }}>
                              Assigned To
                            </th>
                          </tr>
                        </thead>
                      </table>
                    </td>
                  </tr>
                </thead>
                <tbody className="accordion custom-accordion" id="accordionLeads">
                  {currentPageData && currentPageData.sort((a,b) => b[leadSorting] - a[leadSorting]).map((leadData, index) =>
                  
                      <LeadItem
                        leadData={leadData}
                        key={index}
                        lead_index={index}
                        openPlainTextEmail={openPlainTextEmail}
                        handleAccordionClick={handleAccordionClick}
                        openLead={openLead}
                        createNoteOpenModal={createNoteOpenModal}
                        textLeadModal={textLeadModal}
                        handleMobArrow={handleMobArrow}
                        openDealStageModal={openDealStageModal}
                        openMobArrow={openMobArrow}
                        mobLeadItem={mobLeadItem}
                        cancelMobLeadItem={cancelMobLeadItem}
                        handleNotesMobileModal={handleNotesMobileModal}
                        openNotesMobModal={openNotesMobModal}
                        closeNotesMobModal={closeNotesMobModal}
                        handleSetAppointment={handleSetAppointment}
                        handleTaskDetails={handleTaskDetails}
                        handleAppraisalDetails={handleAppraisalDetails}
                        handleDashTab={handleDashTab}
                      />
                    )}
                </tbody>
              </table>
              {/* Pagination */}
              <div className='text-center pagination-block my-5'>
                <nav>
                  <ul className="pagination">
                    {/* Render previous button */}
                    <li className="page-item back-item" key={'start'}>
                      <a className={`page-link ${currentPage === 1 ? "disabled" : ""}`} onClick={prevPage} disabled={currentPage === 1}>
                        Back
                      </a>
                    </li>
                    {/*console.log(singlePagination)*/}
                    {/* Render pagination buttons */}
                    {!singlePagination && paginationButtons.map((v, i) => {
                      return (
                        <li className="page-item" key={v}>
                          <a key={v} onClick={() => handlePageChange(v)} className={v === currentPage ? "active page-link" : "page-link"}>
                            {v}
                          </a>
                        </li>
                      )
                    })

                    }
                    {singlePagination && <a key={1} className={"active page-link"}>{1}</a>}
                    <li className="page-item next-item">
                      <a className={`page-link ${currentPage === totalPages ? "disabled" : ""}`} onClick={nextPage} disabled={currentPage === totalPages}>
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </>
          }
          {/* <div className="lead-item" ref={lastItemRef}></div> */}
        </div>
      </div>
      {/* <!-- Modal --> */}
      <ModalLayout open={plainTextEmail} close={paintextEmailClose}>
        <PlainTextEmail
          leadData={selectedLead}
          onAddScriptBtnClick={(type="email") => {
            setScriptModal(true);
            setScriptType(type);
          }}
          close={paintextEmailClose}
          selectedScript={selectedScript}
        />
      </ModalLayout>
      <ModalLayout open={addScriptModal} close={scriptModalClose} >
        <ScriptModal
          close={scriptModalClose} 
          scriptType={scriptType}
          scriptFilter={"web"} />
      </ModalLayout>
      <ModalLayout open={createNoteOpen} cls="mxw-550" close={createNoteCloseModal}>
        <CreateNotesModal close={createNoteCloseModal} leadData={noteLeadData} />
      </ModalLayout>

      <ModalLayout open={textLead} cls="mxw-750" close={textLeadCloseModal}>
        <TextLead
          close={textLeadCloseModal}
          leadData={selectedLead}
          onAddScriptBtnClick={(type="email") => {
            setScriptModal(true);
            setScriptType(type);
          }}
        />
      </ModalLayout>


      <ModalLayout open={dealStageModal} cls="mxw-750" waitingCls="update-deal-bg" close={closeDealStageModal}>
        <WaitingResponseModal close={closeDealStageModal} leadData={dealStageLeadData}/>
      </ModalLayout>
      <ModalLayout open={openSetAppointment} waitingCls="true" modalWidth="1198px" cls="blue-header-modal" close={closeSetAppointment}>
        <SetAppointmentModal close={closeSetAppointment} leadData={selectedLead} updateLeadDataMultiple={updateLeadDataMultiple}/>
      </ModalLayout>
      <ModalLayout open={openTaskDetails} waitingCls="true" modalWidth="780px" cls="blue-header-modal" close={closeTaskDetails}>
        <TaskDetailsModal 
          close={closeTaskDetails}
          openEditTaskDetails={openEditTaskDetails}
          updateTask={updateTask}
          updateLeadDataMultiple={updateLeadDataMultiple}
          noUpdateStage={true}
        />
      </ModalLayout>

        <ModalLayoutNew open={openAppraisalModal} close={closeAppraisalDetails} darkThemeCls='true' modalWidth={1198}>
            <AppraisalDetails
                close={closeAppraisalDetails}
                appraisalData={openAppraisalDetails}
                appraisalStage={"NewLead"}
            />
        </ModalLayoutNew>
        {/*noteRemoveAlert &&
          <AlertModal
            open={noteRemoveAlert}
            close={closeNoteRemove}
            handleSendNoteData={handleSendNoteData}
          />
        */}
    </>
  );
};

export default Leads;
